export default "__VITE_ASSET__BjQTr3Kp__"